import withStyles from '@mui/styles/withStyles';
import "components/styles/AgreeabilityScale.scss";
import React from "react";
import ReactPlayer from 'react-player';


const styles = theme => {
  return (
    {
      playerWrapper: {
        position: 'relative',
        paddingTop: '56.25%'
      },
      reactPlayer: {
        position: 'absolute',
        top: 0,
        left: 0,
      }
    }
  );
};

const Video = ({onAnswered, value, videoId = "", classes, autoPlay}) => {

  const videoUrl = `https://www.youtube.com/watch?v=${videoId}`;
  return (
    <div id="Youtube-video" className={classes.playerWrapper}>
      <ReactPlayer url={videoUrl}
                   controls
                   width='100%'
                   height='100%'
                   className={classes.reactPlayer}
                   playing={autoPlay}
      />
    </div>
  );
};


export default withStyles(styles)(Video);
